import { MIN_WIDTH } from "src/globals";
import { commonStyles } from "src/Library/CommonStyles";

export const VesselSchedulesStyles = (theme) => ({
  '@keyframes loading': {
    from: {opacity: '0.5'},
    to: {opacity:  '1'},
  },
  mainDiv: {
    minWidth: MIN_WIDTH,
    backgroundColor: '#F5F4F2',
  },
  filtersDiv: {
    width: '95%',
    paddingLeft: '24px',
    marginTop: '5px',
  },
  filterTitle: {
    ...commonStyles(theme).justifySpaceBetween,
    backgroundColor: theme.colors.bgSubtle,
    paddingBottom: '12px',
  },
  routeCheckbox: {
    ...commonStyles(theme).flexColumn,
    marginLeft: '8px',
    '& .ant-checkbox-wrapper': {
      marginLeft: 0,
      marginTop: '6px',
      fontSize: '12px',
      fontWeight: 600,
      '& .ant-checkbox-inner': {
        height: '14px',
        width: '14px',
      },
      '& .ant-checkbox-checked .ant-checkbox-inner': {
        backgroundColor: theme.colors.primaryDark,
        borderColor: theme.colors.primaryDark,
        height: '14px',
        width: '14px',
      },
    },
  },
  daysButton: {
    cursor: 'pointer',
    fontSize: '12px',
    textAlign: 'center',
    height: '19px',
    width: '19px',
    borderRadius: 15,
    backgroundColor: theme.colors.bgWhite,
    border: '1px solid #BBBBBB',
    color: '#BBBBBB',
    marginRight: '10px',
    '&:hover': {
      borderColor: theme.colors.primaryDark,
      color: theme.colors.primaryDark,
    },
  },
  daysButtonSelected: {
    backgroundColor: theme.colors.primaryDark,
    color: theme.colors.bgWhite,
    border: `1px solid ${theme.colors.primaryDark}`,
    '&:hover': {
      borderColor: theme.colors.primaryDark,
      color: theme.colors.bgWhite,
    },
  },
  daysButtonDisabled: {
    cursor: 'not-allowed',
    fontSize: '12px',
    textAlign: 'center',
    height: '19px',
    width: '19px',
    borderRadius: 15,
    border: '1px solid #F5F4F2',
    color: theme.colors.border,
    marginRight: '10px',
    backgroundColor: '#F5F4F2',
  },
  schedule: {
    display: 'flex',
    padding: '16px 0',
  },
  slCheckbox: {
    display: 'flex',
    '& .ant-checkbox + span': {
      fontSize: '12px',
      fontWeight: 600,
      color: theme.colors.textSecondary,
    },
    '& .ant-checkbox-checked .ant-checkbox-inner': {
      backgroundColor: theme.colors.primaryDark,
      borderColor: theme.colors.primaryDark,
    },
  },
  listDiv: {
    maxHeight: '1102px',
    overflowY: 'auto',
    position: 'relative',
  },
  interSectDiv: {
    minHeight: '100px',
  },
  date: {
    color: `${theme.colors.textSecondary} !important`,
    fontWeight: 600,
  },
  portInfo: {
    ...commonStyles(theme).flexRow,
    fontSize: '10px',
    color: `${theme.colors.textSecondary} !important`,
  },
  tooltipStyle: {
    fontSize: '12px',
    '& .ant-tooltip-inner': {
      backgroundColor: theme.colors.textSecondary,
      color: theme.colors.bgWhite,
    },
  },
  cardDiv: {
    width: '96%',
    marginBottom: '12px',
    border: '1px solid #E9E9E9',
    borderRadius: '4px',
    backgroundColor: theme.colors.bgWhite,
  },
  transitDays: {
    ...commonStyles(theme).flexColumn,
    alignItems: 'center',
  },
  bottomContent: {
    marginTop: -10,
    color: theme.colors.textSecondary,
    fontSize: '10px',
    ...commonStyles(theme).ellipses,
  },
  cutOffDate: {
    fontSize: '10px',
    color: '#616362',
    fontWeight: 600,
    fontStyle: 'italic',
    marginTop: '2px',
  },
  ellipsis: {
    ...commonStyles(theme).ellipses,
  },
  landingUI: {
    textAlign: 'center',
    marginTop: '66px',
  },
  landingText: {
    color: theme.colors.textSecondary,
    fontSize: '18px',
  },
  noResultText: {
    fontSize: '21px',
    marginTop: '40px',
    textAlign: 'center',
    fontWeight: 600,
    color: theme.colors.textSecondary,
  },
  terminal: {
    color: '#616362',
    fontSize: '8px',
  },
  container: {
    margin: '9px',
    background: theme.colors.bgWhite,
    height: '100px',
    maxWidth: '96%'
  },
  card: {
    overflow: 'hidden',
    borderRadius: '4px',
    width: '100%',
  },
  cardDetail: {
    padding: '8px 16px',
    backgroundColor: '#f4f4f4',
    margin: 'auto',
    position: 'relative',
    width: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
    animation: 'loading 0.8s infinite' ,
  },
  tncDiv: {
    fontSize: '12px',
    width: '100%',
    color: theme.colors.textSecondary,
    marginTop: '24px',
    fontWeight: '600',
    textAlign: 'left',
    padding: '0px 20px 45px 24px'
  },
  tncTextShowMore: {
    fontSize: '10px',
    paddingLeft: '28px',
    marginTop: '12px',
    '& li' : {
      paddingLeft: '12px',
      marginTop: '10px'
    }
  }
});
